import { Component, ElementRef, OnInit } from '@angular/core';
import {
  FormGroup,
  UntypedFormBuilder,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';

import { AlertBoxComponent } from 'src/app/shared/components/alert-box/alert-box.component';
import { PaymentService } from '../../services/payment/payment.service';
import { RefundService } from '../../services/refund/refund.service';
import { OrderState } from '../../state/order.state';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { OrderDetails } from '../../state/order-action';

@Component({
    selector: 'app-refund',
    templateUrl: './refund.component.html',
    styleUrls: ['./refund.component.scss'],
    standalone: false
})
export class RefundComponent implements OnInit {
  orderId: any;
  order: any;
  refundFormGroup: FormGroup;
  refundTypes = [];
  refundReasons = [];
  showValueField: boolean = false;
  valueMark: string = 'ر.س';
  spinner: boolean = true;
  alertmsg: boolean = false;
  errorMessage: string = 'يوجد خطأ في بعض البيانات';
  saveDialogRef: MatDialogRef<AlertBoxComponent>;
  modelImg: boolean;
  confirmMsg: string;
  backUrl: string;
  changeOrderStatus: boolean = false;
  paymentMethods: any[] = [];
  orderDetails$: Observable<any>;
  remain_cost: any;
  inspector_fees: any;
  payment_fee: any;
  tax: any;
  final_cost: any;
  showRefundView: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private element: ElementRef,
    private formBuilder: UntypedFormBuilder,
    private dialog: MatDialog,
    private paymentService: PaymentService,
    private refundService: RefundService,
    private store: Store
  ) {
    this.orderDetails$ = this.store.select(OrderState.getOrderDetails);
  }

  ngOnInit(): void {
    this.orderId = this.route.snapshot.params.id;
    this.createForm();
    this.createFormControls();
    this.getOrderById(this.orderId);
    this.getRefundType();
    this.getRefundReasons();
    this.getPaymentMethods();
  }

  getOrderById(id) {
    this.orderDetails$.subscribe(
      (res) => {
        if (res?.id) {
          if (!res.is_paid) {
            this.router.navigate(['pages/orders', id]);
          }
          this.spinner = false;
          this.order = res;
          this.refundFormGroup
            .get('orderNumber')
            .setValue(this.order?.reference_number);
        } else {
          this.store
            .dispatch(new OrderDetails({ orderId: +id }))
            .subscribe((res) => {});
        }
      },
      (error) => {
        this.handleBackendError(error);
      }
    );
  }

  createForm() {
    this.refundFormGroup = this.formBuilder.group({
      value: [null],
      test:[null],
      orderNumber: [null, Validators.required],
      refundType: [null, Validators.required],
      refundReason: [null, Validators.required],
      changeOrderStatusToCancel: [false, Validators.required],
      paymentMethod: [null, Validators.required],
    });
  }

  createFormControls() {
    return this.refundFormGroup.controls;
  }

  getRefundType() {
    this.refundService.getRefundType().subscribe(
      (data) => {
        this.refundTypes = data;
      },
      (error) => {
        this.handleBackendError(error);
      }
    );
  }

  getPaymentMethods() {
    this.paymentService.getPaymentMethods().subscribe((data) => {
      this.paymentMethods = data;
    });
  }

  getRefundReasons() {
    this.refundService.getRefundReasons().subscribe(
      (data) => {
        this.refundReasons = data;
      },
      (error) => {
        this.handleBackendError(error);
      }
    );
  }

  TypeChanged(event) {
    if (event === 'CONSTANT_VALUE') {
      this.showValueField = true;
      this.refundFormGroup.addControl(
        'value',
        new UntypedFormControl('', Validators.required)
      );
      this.refundFormGroup.addControl(
        'inspector_share_after_refund',
        new UntypedFormControl('', Validators.required)
      );
    } else {
      this.showValueField = false;
      // this.refundFormGroup.removeControl('value');
      this.refundFormGroup.removeControl('inspector_share_after_refund');
      this.calculateRefundValue();
      this.refundFormGroup.controls.value.setValue(0)
    }
  }

  changeOrderStatusHandler(event) {
    this.refundFormGroup.get(event.labelEn).setValue(event.value);
  }

  save(event) {
    this.removeInvalidClass();
    this.alertmsg = false;
    if (!this.refundFormGroup.valid) {
      this.alertmsg = true;
      const fields = this.element.nativeElement.querySelectorAll(
        '.form-control.ng-invalid, ng-select.ng-invalid, .mat-form-field.ng-invalid'
      );
      fields.forEach((field) => {
        field.classList.add('invalid-field');
      });
    } else {
      this.createManualRefund(this.refundFormGroup.value, event.buttonId);
    }
  }

  createManualRefund(refundData, buttonId) {
    this.refundService.createManualRefund(this.orderId, refundData, buttonId).subscribe(
      (response) => {
        this.modelImg = true;
        this.confirmMsg = 'تم حفظ البيانات بنجاح';
        this.backUrl = `pages/orders/${this.orderId}`;
        this.showAlertBox();
      },
      (error) => {
        this.alertmsg = true;
        this.errorMessage = error.error.message;
      }
    );
  }

  showAlertBox() {
    this.saveDialogRef = this.dialog.open(AlertBoxComponent, {
      data: {
        imgSuccess: this.modelImg,
        message: this.confirmMsg,
        backUrl: this.backUrl,
      },
    });
  }

  removeInvalidClass() {
    const fields =
      this.element.nativeElement.querySelectorAll('.invalid-field');
    fields.forEach((field) => {
      field.classList.remove('invalid-field');
    });
  }

  hideErrorMSG() {
    this.alertmsg = false;
  }

  goOrder() {
    this.router.navigate(['pages/orders', this.orderId]);
  }

  calculateRefundValue() {
    let obj = {
      value: this.refundFormGroup.controls.value.value ? this.refundFormGroup.controls.value.value : 0,
      type: this.refundFormGroup.controls.refundType.value
    }
    this.refundService.calculateRefundValue(this.orderId, obj).subscribe(data => {
        this.showRefundView = true;
        this.final_cost = data.final_cost_before_refund;
        this.remain_cost = data.amount;
        this.inspector_fees = data.inspector_visit_fee;
        this.payment_fee = data.payment_fee;
        this.tax = data.tax;
      },
      (error) => {
        try {
          this.showRefundView = false;
        }
        catch {
          console.log(error);
        }
      }
    )
    }

  handleBackendError(error) {
    try {
      /* TODO document why this block is empty */
    } catch {}
  }
}
